import Head from '@wigets/head.vue'
import Foot from '@wigets/foot.vue'
import {
  activityInfo,
  activityNew,
  getmessage,
  picup,
  checkmessage,
  getById,
  insert,
  setagain,
  joinACtive,
  signupAdd,
  checkPhone,
  binduserInfo,
  useractive,
  companyStatus,
  sendSms,
  uploadFile,
  uploadVideo,
  getPVUV,
  getExcitingNewsByActivityId,
} from '@apis/apis'
import city from '../../../assets/scripts/citydata'
import {
  showcontent,
  verifyVideoTime
} from '@utils/method.js'
import {
  Toast,
  Area,
  Popup,
  Uploader,
  Radio,
  RadioGroup,
  DatetimePicker,
  Picker,
  Field,
  Dialog,
  Checkbox,
  CheckboxGroup,
} from 'vant'
// import areaList from "@/assets/scripts/area.js";
import {
  areaList
} from '@vant/area-data';
import activeIcon from "../../../assets/icons/radio_active.png";
import zlabel from "../../../components/zlabel";
import dinput from "../../../components/dinput";
import inactiveIcon from "../../../assets/icons/radio_deactive.png";
import Loading from '../../../components/Loading'
import {
  genFlag,
  regTel,
  timeFormat
} from "@/utils/method";
import VideoUpload from "@/views/h5/update/uploadd";
export default {
  components: {
    'web-head': Head,
    'web-foot': Foot,
    'van-uploader': Uploader,
    "z-label": zlabel,
    "d-input": dinput,
    "van-area": Area,
    "van-popup": Popup,
    "van-radio": Radio,
    "van-radio-group": RadioGroup,
    "van-datetime-picker": DatetimePicker,
    "van-picker": Picker,
    "van-field": Field,
    "van-checkbox": Checkbox,
    "van-checkbox-group": CheckboxGroup,
    VideoUpload,
    Loading
  },
  data() {
    let validName = (rule, value, next) => {
      rule = /^[\u4e00-\u9fa5]{2,4}$/
      if (!rule.test(value)) {
        return next(new Error('用户名为汉字2-4位'))
      }
      next()
    }
    let valididCard = (rule, value, next) => {
      let year = Number(value.slice(6, 10)) + 18;
      let month = value.slice(10, 12);
      let date = value.slice(12, 14);
      let now = new Date('2021-08-31').getTime()
      let oldtime = new Date(year + '-' + month + '-' + date).getTime()
      if (now < oldtime) {
        return next(new Error('该活动仅限于成年用户参与'))
      }
      next()
    }
    let validPhone = (rule, value, next) => {
      rule = /^1[23456789]\d{9}$/
      if (!rule.test(value)) {
        return next(new Error('手机号违法'))
      }
      next()
    }
    // 验证图片上传
    const vaildImgs = (rule, value, next) => {
      if (value.length < 3) {
        return next(new Error('至少上传3张截图'))
      }
      next()
    }
    return {
      //hoawnaghuo
      activeIcon,
      inactiveIcon,
      columns: ['日用品类', '家电器材类', '粮油食品类', '服装鞋帽针织品类', '文化办公用品类', '体育娱乐用品类', '饮料类', '烟酒类'],
      minDate: new Date(1980, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      areaList,
      prevImg: true,
	  disableded: true,
      outputInfo: ["10万", "20万", "30万"],
      salesInfo: ["10万", "20万", "30万"],
      salesChannelInfo: ["代理", "网点"],
      netChannelInfo: ["淘宝", "京东"],
      netPercentInfo: ["10%", "20%", "30%"],
      highReasonInfo: [{
        values: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ],
        defaultIndex: 0,
      },
      {
        values: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ],
        defaultIndex: 0,
      },
      ],
      highSales: [{
        month: 1,
        check: false
      },
      {
        month: 2,
        check: false
      },
      {
        month: 3,
        check: false
      },
      {
        month: 4,
        check: false
      },
      {
        month: 5,
        check: false
      },
      {
        month: 6,
        check: false
      },
      {
        month: 7,
        check: false
      },
      {
        month: 8,
        check: false
      },
      {
        month: 9,
        check: false
      },
      {
        month: 10,
        check: false
      },
      {
        month: 11,
        check: false
      },
      {
        month: 12,
        check: false
      },
      ],
      userflag: "",
      successLayer: false,
      agreeProtocol: "",
      pingtai: [],
	  aboutus: '',
	  salestaobao: 0,
	  salestianmao: 0,
	  salespinduoduo: 0,
	  salesjingdong: 0,
	  salesdouyin: 0,
	  saleskuaishou: 0,
	  salesqita: 0,
	  buyertaobao: 0,
	  buyertianmao: 0,
	  buyerpinduoduo: 0,
	  buyerjingdong: 0,
	  buyerdouyin: 0,
	  buyerkuaishou: 0,
	  buyerqita: 0,
	  
      verifyInfo: {},
      verifyStatus: -1,
      failInfoDes: "",
      failInfoList: [],
      // 浮层
      areaLayer: false,
      publishLayer: false,
      outputLayer: false,
      productTypelay: false,
      salesLayer: false,
      salesChannelLayer: false,
      netChannelLayer: false,
      netPercentLayer: false,
      highReasonLayer: false,

      // ---- ajax信息 ---
      // 企业信息
      companyName: "",
      businessLicenseImgs: [],
      businessLicenseImgs_: [],
	  cityCode: "",
      // 基本信息
      productName: "",
      choosedArea: [],
      choosedAreaDes: "",
      areaDetail: "",
      packingImgs: [],
      packingImgs_: [],
	  
	  qita1name: "",
	  salesqita1: "",
	  buyerqita1: "",
	  
	  qita2name: "",
	  salesqita2: "",
	  buyerqita2: "",
	  
	  qita3name: "",
	  salesqita3: "",
	  buyerqita3: "",
	  
	  qita4name: "",
	  salesqita4: "",
	  buyerqita4: "",
	  
	  qita5name: "",
	  salesqita5: "",
	  buyerqita5: "",
	  
	  qita6name: "",
	  salesqita6: "",
	  buyerqita6: "",
	  
	  qita7name: "",
	  salesqita7: "",
	  buyerqita7: "",
	  
	  qita8name: "",
	  salesqita8: "",
	  buyerqita8: "",
	  
	  qita9name: "",
	  salesqita9: "",
	  buyerqita9: "",
	  
	  qita10name: "",
	  salesqita10: "",
	  buyerqita10: "",
	  
	  qita: 1,
	  taobaosalesImgs: [],
	  taobaosalesImgs_: [],
	  taobaobuyerImgs: [],
	  taobaobuyerImgs_: [],
	  
	  tianmaosalesImgs: [],
	  tianmaosalesImgs_: [],
	  tianmaobuyerImgs: [],
	  tianmaobuyerImgs_: [],
	  
	  pinduoduosalesImgs: [],
	  pinduoduosalesImgs_: [],
	  pinduoduobuyerImgs: [],
	  pinduoduobuyerImgs_: [],
	  
	  jingdongsalesImgs: [],
	  jingdongsalesImgs_: [],
	  jingdongbuyerImgs: [],
	  jingdongbuyerImgs_: [],
	  
	  douyinsalesImgs: [],
	  douyinsalesImgs_: [],
	  douyinbuyerImgs: [],
	  douyinbuyerImgs_: [],
	  
	  kuaishousalesImgs: [],
	  kuaishousalesImgs_: [],
	  kuaishoubuyerImgs: [],
	  kuaishoubuyerImgs_: [],
	  
	  qita1salesImgs: [],
	  qita1salesImgs_: [],
	  qita1buyerImgs: [],
	  qita1buyerImgs_: [],
	  
	  qita2salesImgs: [],
	  qita2salesImgs_: [],
	  qita2buyerImgs: [],
	  qita2buyerImgs_: [],
	  
	  qita3salesImgs: [],
	  qita3salesImgs_: [],
	  qita3buyerImgs: [],
	  qita3buyerImgs_: [],
	  
	  qita4salesImgs: [],
	  qita4salesImgs_: [],
	  qita4buyerImgs: [],
	  qita4buyerImgs_: [],
	  
	  qita5salesImgs: [],
	  qita5salesImgs_: [],
	  qita5buyerImgs: [],
	  qita5buyerImgs_: [],
	  
	  qita6salesImgs: [],
	  qita6salesImgs_: [],
	  qita6buyerImgs: [],
	  qita6buyerImgs_: [],
	  
	  qita7salesImgs: [],
	  qita7salesImgs_: [],
	  qita7buyerImgs: [],
	  qita7buyerImgs_: [],
	  
	  qita8salesImgs: [],
	  qita8salesImgs_: [],
	  qita8buyerImgs: [],
	  qita8buyerImgs_: [],
	  
	  qita9salesImgs: [],
	  qita9salesImgs_: [],
	  qita9buyerImgs: [],
	  qita9buyerImgs_: [],
	  
	  qita10salesImgs: [],
	  qita10salesImgs_: [],
	  qita10buyerImgs: [],
	  qita10buyerImgs_: [],
	  
      liveshotImgs: [],
      delegateProductPermit: [],
      liveshotImgs_: [],
      anotherProLicenseImgs: [],
      anotherProLicenseImgs_: [],
      certification: "1",
      healthFoodsImgs: [],
      another: [],
      healthFoodsImgs_: [],
      healthLicenseImgs: [],
      healthLicenseImgs_: [],
      purchaseImgs: [],
      brandRegisterCardBackL: [],
      otherProductQualification: [],
      productWrap: [],
      productReal: [],
      purchaseImgs_: [],
      otherLicenseImgs: [],
      otherLicenseImgs_: [],

      // 商标信息
      brandMethod: "1",
      brandFrontImgs: [],
      brandFrontImgs_: [],
      brandBackImgs: [],
      brandBackImgs_: [],
      brandRegisterCardFront: [],
      thirdBusinessLicenseImgs: [],
      thirdBusinessLicense: [],
      thirdBusinessLicenseImgs_: [],
      transferExplain: "",

      // 质量信息
      productMethod: "1",
      productLicenseImgs: [],
      productPermit: [],
      freshAgreement: [],
      productLicenseImgs_: [],
      sanitaryPermit: [],
      delegateBusinessLicense: [],

      clientProductLicenseImgs: [],
      clientProductLicenseImgs_: [],
      approvalCertificate: [],
      clientBusinessLicenseImgs: [],
      qualityInspectionReport: [],
      clientBusinessLicenseImgs_: [],
      clientProtocolImgs: [],
      clientProtocolImgs_: [],
      qualityImgs: [],
      qualityImgs_: [],

      // 销售信息
      publishTime: "",
      output: "",
      sales: "",
      salesChannel: "",
      netChannel: "",
      netPercent: "",
      highReason: [],
      highReasonDes: "",
      sellingPoints: "",

      // 联系信息
      sendSms: false,
      smsTime: 0,
      contactUser: "",
      productType: '',
      contactPhone: "",
      wxNo: "",
      post: "",
	  sendAddress: "",
      email: "",
      captcha: "",
      //
      fileList: [],
      videoUrl: '',
      poster: '', //视频封面
      mubanlist: [],
      thumb: '',
      activityImages: [],
      urls: ["http://anhuiec.oss-cn-hangzhou.aliyuncs.com/fc9a2a5ba61a426f86f4a1ba752ed566--2f1c5705084bb17a8dff12c6660a6b4--.png"],
      preVideo: [],
      value: [],
      enclosure: '',
      //活动总览相关
      activityPreviewData: [],
      classObj: { //动态绑定样式
        activityWholeItem2: false,
        activityWholeItem3: false,
        iconJiazaixiao: false,
        iconDuihao: false
      },
      icons: [ //动态绑定icon图标样式
        'icon-qidong',
        'icon-baoming',
        'icon-peixunzuzhizhe-peixunjihua',
        'icon-jiangbei',
      ],
      timeUp: false,
      wantUp: false,
      checkResult: false,
      openid: '',
      checkForm: false,
      checkPhones: '',
      checkActive: false,
      msg: '',
      time: '',
      usercard: '',
      picup,
      imageUrl: '',
      //距离活动开始时间
      overtime: '',
      //短信验证模块
      clickMessage: 0,
      setIntervalMessage: '',
      //获取验证码按钮
      getmessages: '短信验证',
      //一级模块
      tab: 5,
      //二级模块
      nav: 1,
      id: 0,
      page: 1,
      pageSize: 5,
      city,
      //展示的数据
      result: {},
      //是否登录
      logins: false,
      //是否展示新闻
      shownewsNow: false,
      //活动新闻详情
      shownewsInfo: {},
      //活动是否在进行
      ifOn: true,
      //活动详情
      activeInfo: {},
      //活动列表
      activityNews: [],
      //活动id
      activityId: '',
      picPath: '',
      showNews: false,
      total: 0,
      registers: false,
      activesStop: 0,
	  shifouxianshi: 1,
      overin: true,
      overout: true,
      options: [{
        value: '淘宝',
        label: '淘宝'
      }, {
        value: '天猫',
        label: '天猫'
      }, 
      {
        value: '拼多多',
        label: '拼多多'
      }, {
        value: '京东',
        label: '京东'
      }, {
        value: '抖音',
        label: '抖音'
      }, {
        value: '快手',
        label: '快手'
      }, {
        value: '其他',
        label: '其他'
      }
      ],
      doptions: [{
        value: 'taobao',
        label: '淘宝'
      }, {
        value: 'tianmao',
        label: '天猫'
      }, 
      {
        value: 'pinduoduo',
        label: '拼多多'
      }, {
        value: 'jingdong',
        label: '京东'
      }, {
        value: 'douyin',
        label: '抖音'
      }, {
        value: 'kuaishou',
        label: '快手'
      }, {
        value: 'qita',
        label: '其他'
      }
      ],
      option: [{
        value: "1",
        label: '在校学生'
      }, {
        value: "2",
        label: '社会人士'
      }],
      users: {
        phone: '',
        key: '',
        openid: '',
        userType: '3'
      },
      userphone: '',
      actives: 1,
      user: {
        userName: '',
        phone: '',
        key: '',
        idCard: '',
        cityCode: '',
        type: '',
        productType: '',
        userType: '',
        // screenshot: '',
        activitiesId: 0,
        activitiesIdd: '',
        otherInfos: {
          Liveaccount: '',
          Liveintroduce: '',
          platform: '',
          LiveName: '',
          platforms: '',
        },
        otherInfo: {
          Liveaccount: '',
          Liveintroduce: '',
          LiveName: '',
          platform: '',
        },
      },
      askIfphone: false,
      nosure: true,
      props: {
        expandTrigger: 'hover',
        label: "text",
      },
      UserRule: {
        cityCode: [{
          required: true,
          message: '请选择所在地区',
          trigger: 'blur'
        }, ],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        },
        {
          validator: validPhone,
          trigger: 'blur'
        },
        ],
        key: [{
          required: true,
          message: '验证码不能为空',
          trigger: 'blur'
        }, ],
      },
      UserRules: {
        userName: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        },
        {
          validator: validName,
          trigger: 'blur'
        },
        ],
        key: [{
          required: true,
          message: '验证码不能为空',
          trigger: 'blur'
        }, ],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        },
        {
          validator: validPhone,
          trigger: 'blur'
        },
        ],
        idCard: [{
          required: true,
          message: '请输入身份证号码',
          trigger: 'blur'
        },
        {
          validator: valididCard,
          trigger: 'blur'
        },
        ],
        userType: [{
          required: true,
          message: '请选择职业',
          trigger: 'blur'
        }, ],
        platform: [{
          required: true,
          message: '请选择参赛平台',
          trigger: 'blur'
        }, ],
        cityCode: [{
          required: true,
          message: '请选择参赛地区',
          trigger: 'blur'
        }, ],
        // imgArrs: [
        //   { required: true, message: '请上传图片', trigger: 'change' },
        //   { validator: vaildImgs, trigger: 'change' }
        // ]
      }

    }
  },
  created() {
    //获得活动信息
    this.getinfo()
    //判断用户是否从公众号进来
    this.ifUserGo()
    //获取活动总览信息
    this.getActivitiesPreview(),
    this.getpvuv()
    this.getActivitiesPreview()
  },
  mounted() {
    const userflag = localStorage.getItem("userflag");
    if (!userflag) {
      this.userflag = genFlag();
      localStorage.setItem("userflag", this.userflag);
    } else {
      this.userflag = userflag;
    }
    this.initData();
    this.getCompanyStatus();
    // console.log(JSON.parse(localStorage.getItem('videoInfo')));
    const user = JSON.parse(localStorage.getItem('videoin'))
    // debugger
    if (user) this.user = user
    this.videoUrl = localStorage.getItem('videoUrl1') || ''
    this.poster = localStorage.getItem('videoPoster1') || ''
    if (this.videoUrl && this.poster) {
      this.fileList = [{}]
      this.$nextTick(() => {
        this.$refs.closeLoading.closeLoading()
      })
    }
    console.log(this.user);
  },
  computed: {
    // 过滤掉名字中间的空格user.userName
    filterNameSpace: {
      set(val) {
        this.user.userName = val.replace(/(\s)*/g, '')
      },
      get() {
        return this.user.userName
      }
    },
    // 过滤掉身份证号码中间的空格user.idCard
    filterCardSpace: {
      set(val) {
        this.user.idCard = val.replace(/(\s)*/g, '')
      },
      get() {
        return this.user.idCard
      }
    }
  },
  methods: {
	qitaSub(){
		if(this.qita <= 1){
			Toast('不得少于1个其他平台');
		} else {
			this.qita--
		}
	},
	qitaAdd(){
		if(this.qita >= 10){
			Toast('不得超过10个其他平台');
		} else {
			this.qita++
		}
	},
    // 埋点
    getpvuv(){
      this.$ajaxPost(getPVUV,{
        ip: sessionStorage.getItem('ip'),
        directoryOne: "活动赛事",
        directoryTwo: "活动内容",
        directoryThree: null,
        cookie: sessionStorage.getItem('random')
      })
    },
    //删除图片
    deletea(e, index) {
      this.businessLicenseImgs_.splice(index.index, 1)
      this.businessLicenseImgs.splice(index.index, 1)
    },
    //产品包装图
    deleteb(e, index) {
      this.packingImgs.splice(index.index, 1)
      this.packingImgs_.splice(index.index, 1)
      // this.productWrap.splice(index, 1)
    },
    deletec(e, index) {
      this.liveshotImgs_.splice(index.index, 1)
      this.liveshotImgs.splice(index.index, 1)
    },
    deleted(e, index) {
      this.anotherProLicenseImgs_.splice(index.index, 1)
      this.anotherProLicenseImgs.splice(index.index, 1)

    },
    deletee(e, index) {
      this.purchaseImgs_.splice(index.index, 1)
      this.purchaseImgs.splice(index.index, 1)

    },
    deletef(e, index) {
      this.otherLicenseImgs_.splice(index.index, 1)
      this.otherLicenseImgs.splice(index.index, 1)

    },
    deleteg(e, index) {
      this.healthFoodsImgs_.splice(index.index, 1)
      this.healthFoodsImgs.splice(index.index, 1)

    },
    deleteh(e, index) {
      this.healthLicenseImgs_.splice(index.index, 1)
      this.healthLicenseImgs.splice(index.index, 1)

    },
    deletei(e, index) {
      this.brandFrontImgs.splice(index.index, 1)
      this.brandFrontImgs_.splice(index.index, 1)

    },
    deletej(e, index) {
      this.brandBackImgs_.splice(index.index, 1)
      this.brandBackImgs.splice(index.index, 1)

    },
    deletek(e, index) {
      this.thirdBusinessLicenseImgs_.splice(index.index, 1)
      this.thirdBusinessLicenseImgs.splice(index.index, 1)

    },
    deletel(e, index) {
      this.productLicenseImgs_.splice(index.index, 1)
      this.productLicenseImgs.splice(index.index, 1)

    },
    deletem(e, index) {
      this.clientProductLicenseImgs_.splice(index.index, 1)
      this.clientProductLicenseImgs.splice(index.index, 1)

    },
    deleten(e, index) {
      this.clientBusinessLicenseImgs_.splice(index.index, 1)
      this.clientBusinessLicenseImgs.splice(index.index, 1)

    },
    deleteo(e, index) {
      this.clientProtocolImgs_.splice(index.index, 1)
      this.clientProtocolImgs.splice(index.index, 1)

    },
    deletep(e, index) {
      this.qualityImgs_.splice(index.index, 1)
      this.qualityImgs.splice(index.index, 1)

    },
    laytype() {
      this.productTypelay = true
    },
    onConfirm(value, index) {
      this.productType = value
      this.productTypelay = false

      console.log(this.productType);
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onChange(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancel() {
      Toast('取消');
    },
    // 埋点
    getpvuv() {
      this.$ajaxPost(getPVUV, {
        ip: sessionStorage.getItem('ip'),
        directoryOne: "活动赛事",
        directoryTwo: "活动内容",
        directoryThree: null,
        cookie: sessionStorage.getItem('random')
      })
    },
    // 查看视频详情
    navToVideoShow() {
      const {
        videoUrl,
        user
      } = this
      if (videoUrl) {
        localStorage.setItem('videoin', JSON.stringify({
          ...user
        }))
        this.$router.push({
          name: 'videoShow',
          query: {
            video: this.videoUrl,
            videoPoster: this.poster
          }
        })
      } else {
        Toast('请等待视频上传完成')
      }
    },
    //上传视频前
    async beforeRead(file) {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '上传中...',
      });
      await verifyVideoTime(file)
    },
    //上传视频后
    afterRead({
      file
    }) {
      Toast.clear();
      const that = this
      const formData = new FormData()
      formData.append("file", file)
      formData.append("dirName", 'asd')
      this.$ajaxPost(uploadVideo, formData).
      // uploadVideo(formData).
        then(res => {
          if (res.data.code == 0) {
            console.log(res.data.videoUrl);
            this.videoUrl = res.data.data
            this.poster = res.data.data + '?x-oss-process=video/snapshot,t_1000,f_jpg'
            localStorage.setItem('videoUrl1', this.videoUrl)
            localStorage.setItem('videoPoster1', this.poster)
            // 返回处理  指定帧 的图片
            // return getVideoBase64(res.data.videoUrl, 20)
            Toast({
              type: 'success',
              message: '上传成功',
              // message: res.msg,
              duration: 1000,
              onClose() {
                that.$refs.closeLoading.closeLoading()
              }
            })
          } else {
            this.$refs.closeLoading.closeLoading()
            this.videoUrl = ''
            this.fileList = []
            Toast.fail(res.msg || '上传失败')
          }
        }).catch(err => {
          this.$refs.closeLoading.closeLoading()
          this.videoUrl = ''
          this.fileList = []
          Toast.fail(err.msg || '上传失败')
        })
    },
    // 删除按钮删除视频封面以及视频
    deleteFileList() {
      localStorage.setItem('videoUrl1', '')
      localStorage.setItem('videoPoster1', '')
      this.videoUrl = ''
      this.poster = ''
      this.fileList = []
    },
    onOversize(file) {
      console.log(file, '文件大小不能超过500M');
      Toast('文件大小不能超过 500M');
    },
    showcontent,
    //动态绑定样式
    dynamicStyle() {
      let currentDate = +new Date(new Date())
      this.activityPreviewData.forEach((item, index) => {
        let startDate = +new Date(new Date(item.activitiesStartTime))
        let endDate = +new Date(new Date(item.activitiesEndTime))
        if (currentDate < endDate && currentDate > startDate) {
          this.classObj.activityWholeItem2 = true
          this.classObj.activityWholeItem3 = false
          this.classObj.iconJiazaixiao = true
          this.classObj.iconDuihao = false
        } else if (currentDate > endDate) {
          this.classObj.activityWholeItem3 = true
          this.classObj.activityWholeItem2 = false
          this.classObj.iconJiazaixiao = false
          this.classObj.iconDuihao = true
        }

      })
    },
    //确认提交报名信息
    changWantUp() {
      const nowTime = Date.now();
      if (nowTime > +new Date('2023-8-24 23:59:59')) {
        this.timeUp = true
      } else {
        this.wantUp = true
      }

    },
    //取消提交报名信息
    cancalUpload() {
      this.wantUp = false
    },
    //关闭报名时间提示
    cancalInfo() {
      this.timeUp = false
    },
    //重新报名
    setagain() {
      let arr = []
      arr.push(this.result.id)
      this.$ajaxPost(`${setagain}`, arr).then(res => {
        if (res.data.code != 0) {
          this.$message({
            title: "错误",
            type: "error",
            message: "重新报名失败",
          })
        } else {
          this.$message({
            title: "成功",
            type: "success",
            message: "",
          })
          window.location.href = 'https://new.anhuiec.com/#/activitiesInfo?id=7';
        }
      }).catch(err => {
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type: "error",
          callback: () => {
            location.reload()
          }
        })
      })
    },
    //取消查询手机号
    noask() {
      this.checkForm = true
      this.askIfphone = false
    },
    //确定查询手机号
    suerask() {
      let option = this.$route.query
      this.$ajaxGet(`${checkPhone}`, {
        phone: this.checkPhones,
        acId: Number(option.id)
      }).then(res => {
        // 0, 1, 500 
        if (res.data.code == 500) {
          this.$message({
            title: "错误",
            type: "error",
            message: "此手机号未参与报名",
          })
        } else {
          this.result = res.data.data
          this.$ajaxPost(`${binduserInfo}`, {}, {
            phone: this.checkPhones,
            openid: this.openid
          }).then(res => {
            if (res.data.code != 0) {
              this.$message({
                title: "错误",
                type: "error",
                message: res.data.msg,
              })
              return
            } else {
              this.$router.go(0)
            }
          }).catch(err => {
            this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
              confirmButtonText: '确定',
              type: "error",
              callback: () => {
                location.reload()
              }
            })
          })
        }
      }).catch(err => {
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type: "error",
          callback: () => {
            location.reload()
          }
        })
      })
    },
    //关闭弹框
    closeForm() {
      this.checkForm = false
    },
    //检测需要查询的手机号是否符合要求
    checkedForm() {
      let rule = /^1[23456789]\d{9}$/
      if (!rule.test(this.checkPhones)) {
        this.$message({
          title: "错误",
          type: "error",
          message: "请正确填写手机号",
        })
      } else {
        this.askIfphone = true
      }
    },
    //确定信息
    sureclick() {
      this.nosure = false
    },
    //微信授权
    showinfo() {
      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx75beffe30132c918&redirect_uri=http%3A%2F%2Fnew.anhuiec.com%2Fapi%2Fwx%2Fcallback&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
    },
    //用户报名信息提交
    uploadInfo() {
      if (typeof this.user.otherInfo == 'string') {
        this.user.otherInfo = JSON.parse(this.user.otherInfo)
      }
      this.user.otherInfo.Liveaccount = this.user.otherInfos.Liveaccount
      this.user.otherInfo.Liveintroduce = this.user.otherInfos.Liveintroduce
      this.user.otherInfo.LiveName = this.user.otherInfos.LiveName
      if (this.user.otherInfos.platform == '其他' && this.user.otherInfos.platforms.trim() != '') {
        this.user.otherInfo.platform = this.user.otherInfos.platforms
        this.user.type = this.user.otherInfos.platforms
      } else {
        this.user.otherInfo.platform = this.user.otherInfos.platform
        this.user.type = this.user.otherInfos.platform
      }
      this.user.otherInfo = JSON.stringify(this.user.otherInfo)
      this.user.videoUrl = this.videoUrl
      this.user.videoPicture = this.poster

      const newObj = {
        ...this.user
      }
      delete newObj.otherInfos
      this.$ajaxPost(`${joinACtive}`, newObj).then(res => {
        console.log(res);
        if (res.data.code != 0) {
          this.$message({
            title: "错误",
            type: "error",
            message: res.message,
          })
          if (res.data.code == 202) {
            this.$message({
              title: "错误",
              type: "error",
              message: "身份证重复",
            })
          } else if (res.data.code == 201) {
            this.$message({
              title: "错误",
              type: "error",
              message: "手机号码重复",
            })
          } else {
            this.$message({
              title: "错误",
              type: "error",
              message: "报名失败",
            })
          }
        } else {
          this.activesStop = 1
          this.result.verifyStatus = 0
          this.checkActive = false
          this.nosure = false
          this.checkResult = true
          this.askIfphone = false
          this.checkForm = false
          this.overin = true
          if (this.openid && this.openid != '') {
            this.$ajaxPost(`${binduserInfo}`, {}, {
              phone: this.user.phone,
              openid: this.openid
            }).then(res => {
              if (res.data.code != 0) {
                return
              }
            }).catch(err => {
              return err
            })
          } else {
            this.activesStop == 1
            this.msg = res.data.msg
          }
        }
      }).catch(err => {
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type: "error",
          callback: () => {
            location.reload()
          }
        })
      })
    },
    //通过id查询模板
    getByIdlist() {
      const id = this.templateId
      this.$ajaxGet(`${getById}?id=${id}`).then(res => {
        res.data.data.content = JSON.parse(showcontent(res.data.data.content))
        // res.data.data.activitiesTopic = JSON.parse(showcontent(res.data.data.activitiesTopic))
        // res.data.data.activitiesContent = JSON.parse(showcontent(res.data.data.activitiesContent))
        this.mubanlist = res.data.data.content
        console.log(this.mubanlist);
      })
    },
    videoUploaded(url, name) {
      console.log(name);
      this.preVideo.push(url)
      // this.enclosure = url;
      // console.log(this.preVideo);
      // console.log(this.enclosure);
      this.enclosure = this.preVideo.toString()
      console.log(this.enclosure);
    },
    removeVideo() {
      this.enclosure = "";
    },
    // 报名
    async changActivieStop() {
      try {
        await Promise.all([
          this.$refs.UserRefactive.validate(),
          this.$refs.UserRefactives.validate()
        ]);
        this.$ajaxPost(`${checkmessage}`, {}, {
          phone: this.user.phone,
          key: this.user.key,
          activitiesId: this.activityId
        }).then(res => {
          if (res.data.code == 201) {
            this.$message({
              title: "错误",
              type: "error",
              message: "手机号重复,请重新输入",
            })
            return
          } else {
            if (res.data.code == 500) {
              this.$message({
                title: "错误",
                type: "error",
                message: "验证码错误,请重新填写",
              })
              return
            }
            if (res.data.code != 0) {
              this.$message({
                title: "错误",
                type: "error",
                message: res.data.msg + ",请重新刷新",
              })
              return
            } else {
              this.uploadInfo()
            }
          }
        }).catch(err => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: '确定',
            type: "error",
            callback: () => {
              location.reload()
            }
          })
        })
      } catch (error) {
        this.$message({
          title: "错误",
          type: "error",
          message: "请填写完整资料",
        })
        return;
      }
    },

    //跳转到公众号
    goothers() {
      window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzUzNDkzMjM0NA==&scene=124#wechat_redirect'
    },
    //跳转到公众号
    gootherss() {
      this.$router.go(0)
      // this.checkResult = false
      // this.askIfphone = false
      // this.checkForm = true
    },
    goothersss() {
      window.location.href = "http://192.168.3.194:8080/#/activitiesInfo?id=7"
      // this.checkResult = false
      // this.askIfphone = false
      // this.checkForm = true
    },
    //获取短信验证码
    getMbmessage(v) {
      let reg = /^1[23456789]\d{9}$/
      if (v == 1) {
        if (!reg.test(this.user.phone)) {
          this.$message({
            title: "错误",
            type: "error",
            message: "请正确填写手机号码",
          })
        } else {
          //点击后60s之后才能获取信息
          this.clickMessage = 60
          this.getmessages = `${this.clickMessage}`
          clearInterval(this.setIntervalMessage)
          this.setIntervalMessage = setInterval(() => {
            this.clickMessage--
            this.getmessages = `${this.clickMessage}`
            if (this.clickMessage == 0) {
              clearInterval(this.setIntervalMessage)
              this.getmessages = ``
            }
          }, 1000);
          //发送验证码
          this.$ajaxPost(`${getmessage}`, {}, {
            phone: this.user.phone,
            activitiesId: this.activityId
          }).then(res => {
            if (res.data.code != 0) {
              this.$message({
                title: "错误",
                type: "error",
                message: "网络错误，请重新刷新",
              })
            } else {
              this.$message({
                title: "成功",
                type: "success",
                message: "短信发送成功",
              })
            }
          }).catch(err => {
            this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
              confirmButtonText: '确定',
              type: "error",
              // callback: () => {
              //   location.reload()
              // }
            })
          })
        }
      } else {
        if (!reg.test(this.users.phone)) {
          this.$message({
            title: "错误",
            type: "error",
            message: "请正确填写手机号码",
          })
        } else {
          //点击后60s之后才能获取信息
          this.clickMessage = 60
          this.getmessages = `请在${this.clickMessage}s后重试`
          clearInterval(this.setIntervalMessage)
          this.setIntervalMessage = setInterval(() => {
            this.clickMessage--
            this.getmessages = `请在${this.clickMessage}s后重试`
            if (this.clickMessage == 0) {
              clearInterval(this.setIntervalMessage)
              this.getmessages = `短信验证`
            }
          }, 1000);
          //发送验证码
          this.$ajaxPost(`${getmessage}`, {}, {
            phone: this.users.phone
          }).then(res => {
            if (res.data.code != 0) {
              this.$message({
                title: "错误",
                type: "error",
                message: "网络错误，请重新刷新",
              })
            }
          }).catch(err => {
            this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
              confirmButtonText: '确定',
              type: "error",
              callback: () => {
                location.reload()
              }
            })
          })
        }
      }
    },

    //获得活动信息
    getinfo() {
      this.$loading({
        fullscreen: true
      })
      let id = this.$route.query.id
      console.log(id);
      this.activityId = id
      this.user.activitiesId = id
      this.$ajaxGet(`${activityInfo}/${id}`, null).then(res => {
        if (res.data.code != 0) {
          this.$message({
            title: "错误",
            type: "error",
            message: res.data.msg + ",请重新刷新",
          })
        } else {
          // debugger
          this.activeInfo = res.data.data
          this.activeInfo.context = this.activeInfo.context
          this.templateId = this.activeInfo.templateId
          this.activitiesIdd = this.activeInfo.id
          console.log(this.activityImages);
          if (this.activeInfo.model == 3) {
            this.ifOn = 0
          } else {
            // debugger
            let date = new Date(res.data.data.endTime).getTime()
            let now = new Date().getTime()
            console.log(date);
            console.log(now);
            if (now > date) {
              this.ifOn = 1
            } else {
              this.ifOn = 2
              this.nav = 1
              //活动时间倒计时
              // let now = new Date().getTime()
              // let dates = res.data.data.endTime
              // dates=dates.replace(/-/g,'/')
              // let overtime = new Date(dates).getTime()
              // let time = overtime - now
              // this.timeInterval=setInterval(() => {
              //   time -= 1000
              //   let minute = parseInt((time % 86400000 % 3600000) / 60000)+'';
              //   let hour = parseInt(time / 3600000%24) + '';
              //   let day = parseInt(time / 3600000/24)+'' ;
              //   let s = parseInt((time % 86400000 % 3600000) % 60000/1000)+'';
              //   this.overtime=(day+'').padStart(2,'0') + "天"+(hour+'').padStart(2,'0') + "小时"+(minute+'').padStart(2,'0') + "分钟"+(s+'').padStart(2,'0') + "秒"
              // }, 1000);
            }
          }

          this.$nextTick(() => {
            this.$loading().close()
          })
          // this.getByIdlist()
        }
        this.getByIdlist()
      }).catch(err => {
        this.$loading().close()
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type: "error",
          callback: () => {
            location.reload()
          }
        })
      })
    },
    //报名
    onSubmit(values) {
      this.enclosure = values.enclosure
      console.log(values);
      // return
      // debugger
      // if(values){
      //   this.$message({
      //     title: "错误",
      //     type: "error",
      //     message: "请先！",
      //   })
      //   return
      // }
      if (JSON.parse(sessionStorage.getItem('user-login')) == undefined) {
        this.$message({
          title: "错误",
          type: "error",
          message: "请先登录！",
        })
        return
      }

      let activitiesId = this.activitiesIdd
      let userId = JSON.parse(sessionStorage.getItem('user-login')).id
      console.log('submit', values);
      this.$ajaxPost(insert, {
        values,
        activitiesId,
        userId
      }).then(res => {
        if (res.data.code == '0') {
          this.$message({
            title: "成功！",
            type: "success",
            message: "报名成功！",
          })
          this.$router.go(-1)
        } else {
          this.$message({
            title: "错误",
            type: "error",
            message: res.data.msg,
          })
          // this.$router.go(-1)
        }
        this.show = false;
        this.enclosure = ''
        this.mubanlist.input.forEach(res => {
          res.itemValue = ''
        })
        console.log(res);
      })
    },
    // 時間戳
    getTime(time) {
      let timeday = Math.round(new Date() / 1000)
      let timestamp = Date.parse(new Date(time).toString()) / 1000;
      return (timestamp - timeday);
    },
    //获取活动总览信息
    getActivitiesPreview() {
      this.$ajaxGet(`/activitiesPreview/listActivitiesPreview?id=${this.activityId}`, null).then(({
        data
      }) => {
        // console.log('活动总览信息',data)
        if (data.code === 0) {
          let list = data.data
          list.forEach(item => {
            item.activitiesTopic = this.showcontent(item.activitiesTopic)
            item.Stime = this.getTime(item.activitiesStartTime)
            item.Etime = this.getTime(item.activitiesEndTime)
            // item.startTime = item.startTime.split(' ')[0]
            // item.endTime = item.endTime.split(' ')[0]
          });
          // console.log(item.Stime);
          this.activityPreviewData = (list)
          console.log(list);
          this.dynamicStyle()
        }
      })
    },

    //进入页面就判断用户是否从公众号进来的
    ifUserGo() {
      // debugger
      let option = this.$route.query
      let users = sessionStorage.getItem('user-login')
      if (users) {
        users = JSON.parse(users)
      }
      if (option.openid) {
        this.checkActive = true
        // this.openid = option.openid || users.openid
        this.openid = option.openid || users.openid
        this.$ajaxGet(`${useractive}`, {
          openid: this.openid,
          acId: Number(option.id)
        }).then(res => {
          if (res.data.code == 500) {
            this.activesStop = 0
            if (option.search == 1) {
              this.checkForm = true
              this.checkResult = false
              this.askIfphone = false
              this.checkPhones = ''
            }
            return
          } else if (res.data.code != 0 && res.data.code != 500) {
            this.$message({
              title: "错误",
              type: "error",
              message: res.data.msg + ",请重新刷新",
            })
            return
          } else {
            this.result = res.data.data
            // this.activesStop = 1
            this.checkActive = false
            this.nosure = false
            this.checkResult = true
            this.askIfphone = false
            this.checkForm = false
            this.overin = true
          }
        }).catch(err => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: '确定',
            type: "error",
            callback: () => {
              location.reload()
            }
          })
        })
      }
      let user = sessionStorage.getItem('user-login')
      if (user) {
        this.checkActive = true
        this.openid = JSON.parse(user).openid
        // this.activesStop = 1
        this.nosure = false
      }
    },
    //新闻详情返回上一页
    checkedThree() {
      this.nav = 3
      this.shownewsNow = false
    },
    //获得活动新闻列表planned
    getnews() {
      let id = this.$route.query.id
      this.$ajaxGet(`${getExcitingNewsByActivityId}?activityId=${id}`).then(res => {
        if (res.data.code != 0) {
          this.$message({
            title: "错误",
            type: "error",
            message: res.data.msg + ",请重新刷新",
          })
        } else {
          this.activityNews = res.data.data
          if (this.activityNews[0] != null) {
            this.activityNews.forEach(item => {
              if (item.activityImages?.length) {
                item.activityImagess = item.activityImages.split(",");
              } else {
                item.activityImagess = this.urls
              }
              let date = new Date(item.createTime)
              item.createTime = date.getFullYear() + '.' + (date.getMonth() + 1 + '').padStart(2, '0') + '.' + date.getDate()
            });
            // this.total = Number(res.data.data.total);
            this.total = 5
          } else if (this.activityNews[0] == null) {
            this.activityNews = []
          } else {
            this.activityNews = []
          }
        }
      }).catch(err => {
        this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
          confirmButtonText: '确定',
          type: "error",
          callback: () => {
            location.reload()
          }
        })
      })
    },
    //切换二级模块
    changnav(v) {
      this.shownewsNow = false
      this.nav = v
      if (v == 3) {
        this.getnews()
      }

    },
    //点击位置导航进行跳转
    navPosition(name) {
      this.$router.push({
        name
      })
    },
    //切换一级模块
    changeTab(val) {
      this.tab = val
    },
    //修改页面的page
    handleCurrentChange(v) {
      this.page = v
      this.changnav(3)
    },
    //显示新闻详情
    shownews(item) {
      this.nav = 4
      this.shownewsNow = true
      this.shownewsInfo = item
      this.shownewsInfo.content = this.shownewsInfo.content
    },
    /**
     * @description: 转义文本navTonewupload
     * @param {*}
     */
    // showcontent(str) {
    //   if (!str) {
    //     return
    //   }
    //   let arrEntities = { lt: '<', gt: '>', nbsp: ' ', amp: '&', quot: '"' }
    //   return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function(all, t) {
    //     return arrEntities[t]
    //   })
    // },
    // 活动总览跳转新闻页面
    navTonewss(id) {
      if(!id){
        this.$message({
          title: "错误",
          type: "error",
          message: "点击失败！",
        })
        return
      }else{
        this.$router.push({ name: 'newss', query: { id,checked:0,page:1} })
      }
      
      // this.$router.push({
      //   name: 'newss',
      //   query: {
      //     id,
      //     checked: 0, 
      //     page: 1
      //   }
      // })
      // this.$router.push({
      //   name: "newss",
      //   query: {
      //     id
      //   }
      // });
    },
    ///haowanghuo
    initData() {
      let savedInfo = localStorage.getItem("save");
      if (!savedInfo) return;
      savedInfo = JSON.parse(savedInfo);
      let highSales = this.highSales;
      savedInfo.highReason.forEach((item) => {
        highSales[item - 1]["check"] = true;
      });
      if (savedInfo) {
        this.highSales = highSales;
        const keys = Object.keys(savedInfo);
        keys.forEach((item) => {
          this[item] = savedInfo[item];
        });
      }
    },
    getCompanyStatus() {
      const id = localStorage.getItem("signupid");
      if (!id) return;
      const postData = {
        id,
      };

      const keyComparison = {
        companyName: "申报单位",
        businessLicense: "营业执照",
        contactUser: "姓名",
        productType: '产品类型',
        contactPhone: "手机",
        wxNo: "微信",
        productName: "产品名称",
        originCountry: "产品原产地",
        productWrap: "产品包装图",
        productReal: "产品实拍图",
        productQualification: "商品类型",
        otherProductQualification: "其他证书",
        approvalCertificate: "保健品批准证",
        sanitaryPermit: "保健品卫生许可证",
        productMode: "生产方式",
        productPermit: "生产许可证",
        delegateProductPermit: "委托方生产许可证",
        delegateBusinessLicense: "委托方营业执照",
        delegateProcessingDeal: "委托方加工协议",
        qualityInspectionReport: "质检合格报告",
        marketTime: "产品上市时间",
        yearlyOutput: "年产量",
        yearlySales: "年销售额",
        existingSalesChannel: "现有销售渠道",
        networkSalesChannel: "网络销售渠道",
        networkSalesRatio: "网络销售占比",
        salesSeason: "产品销售旺季",
        productSellingPoint: "产品介绍",
        brandRegisterCard: "商标",
        brandRegisterCardFront: "商标注册证正面",
        brandRegisterCardBack: "商标注册证反面",
        thirdBusinessLicense: "第三方营业执照复印件",
        freshAgreement: "采购协议",
        another: "产品资质",
      };

      this.$ajax({
        url: companyStatus,
        method: "post",
        data: postData,
      })
        .then((res) => {
          if (res.code == 0) {
            let resData = res.data;
            const date = timeFormat(resData.createTime);
            resData.buildDate = date;
            this.verifyInfo = resData;
            this.verifyStatus = resData.verifyStatus;

            const imgReg = /^\[(.*)\]$/i;
            if (
              imgReg.test(resData.remarks) &&
              imgReg.test(resData.notThroughList)
            ) {
              const failKeys = JSON.parse(resData.notThroughList);
              const failDes = JSON.parse(resData.remarks);
              let desList = [];
              failKeys.forEach((item, index) => {
                const des = keyComparison[item];
                if (des && des !== "") {
                  const remark = failDes[index];
                  if (remark == "") {
                    desList.push(des + ": " + "不符合");
                  } else {
                    desList.push(des + ": " + remark);
                  }
                }
              });
              this.failInfoList = desList;
              this.failInfoDes = desList.join("；");
            } else {
              this.failInfoList = [resData.remarks];
              this.failInfoDes = resData.remarks;
            }
          } else {
            // Toast.fail(res.data.message);
          }
        })
        .catch((err) => {
          console.error(err);
          Toast.fail("查询审核状态失败");
        });
    },
    onOversize() {
      Toast.fail("图片最大5M");
    },
    // 地区选择系列接口
    showLayer(ev) {
      console.log(ev);
      const layer = ev.currentTarget.dataset.code;
      this[layer] = true;
    },
    hideLayer() {
      this.areaLayer = false;
      this.publishLayer = false;
      this.outputLayer = false;
      this.salesLayer = false;
      this.salesChannelLayer = false;
      this.netChannelLayer = false;
      this.netPercentLayer = false;
      this.highReasonLayer = false;
    },
    //---------------
    // 产品上市时间
    choosePublishTime(ev) {
      console.log(ev);
      const date = new Date(ev);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      this.publishTime = year + "-" + month;
      this.publishLayer = false;
    },
    // 选择原产地
    chooseArea(ev) {
      this.areaLayer = false;
      this.choosedArea = ev;
      let des = [];
      ev.forEach((item) => {
        des.push(item.name);
      });
      this.choosedAreaDes = des.join("/");
    },
    // 选择年产量
    chooseOutput(ev) {
      this.output = ev;
      this.outputLayer = false;
    },
    // 选择年销售量
    chooseSales(ev) {
      this.sales = ev;
      this.salesLayer = false;
    },
    // 选择现有销售渠道
    chooseSalesChannel(ev) {
      this.salesChannel = ev;
      this.salesChannelLayer = false;
    },
    // 选择网络销售渠道
    chooseNetChannel(ev) {
      this.netChannel = ev;
      this.netChannelLayer = false;
    },
    // 选择网销占比
    chooseNetPercent(ev) {
      this.netPercent = ev;
      this.netPercentLayer = false;
    },
    // 选择高峰时间
    chooseHighReason(ev) {
      this.highReason = ev;
      this.highReasonDes = ev.join(" ~ ");
      this.highReasonLayer = false;
    },
    chooseHighSales(ev) {
      const highSales = this.highSales;
      const index = ev.currentTarget.dataset.index;
      highSales[index]["check"] = !highSales[index]["check"];
      this.highSales = highSales;
      let res = [];
      highSales.forEach((item) => {
        if (item.check == true) {
          res.push(item.month);
        }
      });
      this.highReason = res;
      this.highReasonDes = res.join(",");
    },
    // 提交前校验
    regInfo() {
      let regList = [
        "companyName",
        "businessLicenseImgs",
        "productName",
        "areaDetail",
        "packingImgs",
        "liveshotImgs",
        "certification",
        "brandMethod",
        "brandFrontImgs",
        "brandBackImgs",
        "productMethod",
        "qualityImgs",
        "publishTime",
        "output",
        "sales",
        "salesChannel",
        "netChannel",
        "netPercent",
        "highReasonDes",
        "sellingPoints",
        "contactUser",
        "productType",
        "contactPhone",
        "wxNo",
        "captcha",
      ];
      let regListDes = [
        "申报单位",
        "营业执照",
        "产品名称",
        "原产地",
        "产品包装图",
        "产品实拍图",
        "产品资质",
        "商标",
        "商标注册证正面",
        "商标注册证反面",
        "生产方式",
        "质检合格报告",
        "产品上市时间",
        "年产量",
        "年销售额",
        "现有销售渠道",
        "网络销售渠道",
        "网络销售占比",
        "产品销售旺季",
        "产品介绍",
        "姓名",
        "产品品类",
        "手机",
        "微信",
        "验证码",
      ];

      const baojian = ["healthFoodsImgs", "healthLicenseImgs"];
      const baojianDes = ["保健食品批准证书", "保健食品卫生许可证"];
      const fresh = ["purchaseImgs"];
      const freshDes = ["采购协议"];

      const thirdBrand = ["thirdBusinessLicenseImgs"];
      const thirdBrandDes = ["第三方营业执照复印件"];

      const productSelf = ["productLicenseImgs"];
      const productSelfDes = ["生产许可证"];
      const productClient = [
        "clientProductLicenseImgs",
        "clientBusinessLicenseImgs",
        "clientProtocolImgs",
      ];
      const productClientDes = [
        "委托方生产许可证",
        "委托方营业执照",
        "委托加工协议",
      ];

      const i = regList.indexOf("certification");
      if (this.certification == "2") {
        regList.splice(i + 1, 0, ...baojian);
        regListDes.splice(i + 1, 0, ...baojianDes);
      } else if (this.certification == "1") {
        regList.splice(i + 1, 0, ...fresh);
        regListDes.splice(i + 1, 0, ...freshDes);
      }

      const brandIndex = regList.indexOf("brandBackImgs");
      if (this.brandMethod == 2) {
        regList.splice(brandIndex + 1, 0, ...thirdBrand);
        regListDes.splice(brandIndex + 1, 0, ...thirdBrandDes);
      }

      const index = regList.indexOf("productMethod");
      if (this.productMethod == "1") {
        regList.splice(index + 1, 0, ...productSelf);
        regListDes.splice(index + 1, 0, ...productSelfDes);
      } else {
        regList.splice(index + 1, 0, ...productClient);
        regListDes.splice(index + 1, 0, ...productClientDes);
      }

      for (let i = 0, len = regList.length; i < len; i++) {
        if (regList[i] == "contactPhone") {
          if (!regTel(this[regList[i]])) {
            Toast.fail("请检查手机号是否正确");
            return false;
          }
        } else {
          if (!this[regList[i]] || this[regList[i]].length == 0) {
            Toast.fail("请检查" + regListDes[i]);
            return false;
          }
        }
      }

      return true;
    },
    submit() {
      const regRes = this.regInfo();
      if (!regRes) return;
      this.saveDraft();
      const postData = {
        companyName: this.companyName,
        businessLicense: this.businessLicenseImgs_,
        contactUser: this.contactUser,
        productType: this.productType,
        contactPhone: this.contactPhone,
        email: this.email,
        post: this.post,
        wxNo: this.wxNo,

        productName: this.productName,
        originCountry: this.areaDetail,
        productWrap: this.packingImgs_,
        productReal: this.liveshotImgs_,
        productQualification: this.certification,
        otherProductQualification: this.otherLicenseImgs_,
        approvalCertificate: this.healthFoodsImgs_,
        sanitaryPermit: this.healthLicenseImgs_,
        productMode: parseInt(this.productMethod),
        productPermit: this.productLicenseImgs_,
        delegateProductPermit: this.clientProductLicenseImgs_,
        delegateBusinessLicense: this.clientBusinessLicenseImgs_,
        delegateProcessingDeal: this.clientProtocolImgs_,
        qualityInspectionReport: this.qualityImgs_,
        marketTime: this.publishTime,
        yearlyOutput: this.output,
        yearlySales: this.sales,
        existingSalesChannel: this.salesChannel,
        networkSalesChannel: this.netChannel,
        networkSalesRatio: this.netPercent,
        salesSeason: this.highReason,
        productSellingPoint: this.sellingPoints,
        productProcess: "",
        potentialReplication: "",
        captcha: this.captcha,
        brandRegisterCard: this.brandMethod,
        brandRegisterCardFront: this.brandFrontImgs_,
        brandRegisterCardBack: this.brandBackImgs_,
        thirdBusinessLicense: this.thirdBusinessLicenseImgs_,
        brandRegisterCardDesc: this.transferExplain,
        freshAgreement: this.purchaseImgs_,
        another: this.anotherProLicenseImgs_,
      };

      this.$ajax({
        url: signupAdd,
        method: "post",
        data: postData,
      })
        .then((res) => {
          if (res.data.code == 0) {
            Dialog({
              title: "报名成功",
              message: "报名编号：" + res.data.data,
            });
            localStorage.setItem("signupid", res.data.data);
            this.getCompanyStatus();
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          } else {
            Toast.fail(res.data.message);
          }
        })
        .catch(() => {
          Toast.fail("报名失败");
        });
    },
    submit2() {
      const regRes = this.regInfo();
      if (!regRes) return;
      this.saveDraft();
      const postData = {
        companyName: this.companyName,
        businessLicense: this.businessLicenseImgs_,
        contactUser: this.contactUser,
        productType: this.productType,
        contactPhone: this.contactPhone,
        email: this.email,
        post: this.post,
        wxNo: this.wxNo,

        productName: this.productName,
        originCountry: this.areaDetail,
        productWrap: this.packingImgs_,
        productReal: this.liveshotImgs_,
        productQualification: this.certification,
        otherProductQualification: this.otherLicenseImgs_,
        approvalCertificate: this.healthFoodsImgs_,
        sanitaryPermit: this.healthLicenseImgs_,
        productMode: parseInt(this.productMethod),
        productPermit: this.productLicenseImgs_,
        delegateProductPermit: this.clientProductLicenseImgs_,
        delegateBusinessLicense: this.clientBusinessLicenseImgs_,
        delegateProcessingDeal: this.clientProtocolImgs_,
        qualityInspectionReport: this.qualityImgs_,
        marketTime: this.publishTime,
        yearlyOutput: this.output,
        yearlySales: this.sales,
        existingSalesChannel: this.salesChannel,
        networkSalesChannel: this.netChannel,
        networkSalesRatio: this.netPercent,
        salesSeason: this.highReason,
        productSellingPoint: this.sellingPoints,
        productProcess: "",
        potentialReplication: "",
        captcha: this.captcha,
        brandRegisterCard: this.brandMethod,
        brandRegisterCardFront: this.brandFrontImgs_,
        brandRegisterCardBack: this.brandBackImgs_,
        thirdBusinessLicense: this.thirdBusinessLicenseImgs_,
        brandRegisterCardDesc: this.transferExplain,
        freshAgreement: this.purchaseImgs_,
        another: this.anotherProLicenseImgs_,
      };

	  let xhr = new XMLHttpRequest();
	  xhr.open('POST', 'https://activity.anhuiec.com/index.php?s=/api/activity/signupAdd', true);
	  xhr.setRequestHeader('Content-type', 'application/json');
	  xhr.onreadystatechange = function () {
		  var res = JSON.parse(xhr.response);
		  // console.log(res.status);
		  if (res.status === 200) {
			Dialog({
			  title: "报名成功",
			  message: "您好，您报名参加2023安徽省好网货大赛已预报名成功。",
			});
		  } else {
			Toast.fail(res.message);
		  }
	  };
	  xhr.send(JSON.stringify({
		form: postData
	  }));
    },
    // 提交前校验
    regInfo3() {
      let regList = [
	    "companyName",
	    "productName",
	    "aboutus",
	    "cityCode",
		"pingtai",
	    "contactUser",
	    "contactPhone",
        "businessLicenseImgs",
        "captcha",
      ];
      let regListDes = [
        "申报单位",
        "产品名称",
		"企业简介",
		"城市",
        "平台选择",
        "姓名",
        "手机",
        "承诺书",
        "验证码",
      ];

      for (let i = 0, len = regList.length; i < len; i++) {
        if (regList[i] == "contactPhone") {
          if (!regTel(this[regList[i]])) {
            Toast.fail("请检查手机号是否正确");
            return false;
          }
        } else {
          if (!this[regList[i]] || this[regList[i]].length == 0) {
            Toast.fail("请检查" + regListDes[i]);
            return false;
          }
        }
      }

      return true;
    },
	submit3() {
	  const regRes = this.regInfo3();
	  if (!regRes) return;
	  this.saveDraft();
	  const postData = {
	    companyName: this.companyName,
	    productName: this.productName,
	    aboutus: this.aboutus,
	    cityCode: this.cityCode,
		pingtai: this.pingtai,
		
		salestaobao: this.salestaobao,
		taobaosalesImgs: this.taobaosalesImgs_,
		buyertaobao: this.buyertaobao,
		taobaobuyerImgs: this.taobaobuyerImgs_,
		
		salestianmao: this.salestianmao,
		tianmaosalesImgs: this.tianmaosalesImgs_,
		buyertianmao: this.buyertianmao,
		tianmaobuyerImgs: this.tianmaobuyerImgs_,
		
		salespinduoduo: this.salespinduoduo,
		pinduoduosalesImgs: this.pinduoduosalesImgs_,
		buyerpinduoduo: this.buyerpinduoduo,
		pinduoduobuyerImgs: this.pinduoduobuyerImgs_,
		
		salesjingdong: this.salesjingdong,
		jingdongsalesImgs: this.jingdongsalesImgs_,
		buyerjingdong: this.buyerjingdong,
		jingdongbuyerImgs: this.jingdongbuyerImgs_,
		
		salesdouyin: this.salesdouyin,
		douyinsalesImgs: this.douyinsalesImgs_,
		buyerdouyin: this.buyerdouyin,
		douyinbuyerImgs: this.douyinbuyerImgs_,
		
		saleskuaishou: this.saleskuaishou,
		kuaishousalesImgs: this.kuaishousalesImgs_,
		buyerkuaishou: this.buyerkuaishou,
		kuaishoubuyerImgs: this.kuaishoubuyerImgs_,
		
		qita1name: this.qita1name,
		salesqita1: this.salesqita1,
		qita1salesImgs: this.qita1salesImgs_,
		buyerqita1: this.buyerqita1,
		qita1buyerImgs: this.qita1buyerImgs_,
		
		qita2name: this.qita2name,
		salesqita2: this.salesqita2,
		qita2salesImgs: this.qita2salesImgs_,
		buyerqita2: this.buyerqita2,
		qita2buyerImgs: this.qita2buyerImgs_,
		
		qita3name: this.qita3name,
		salesqita3: this.salesqita3,
		qita3salesImgs: this.qita3salesImgs_,
		buyerqita3: this.buyerqita3,
		qita3buyerImgs: this.qita3buyerImgs_,
		
		qita4name: this.qita4name,
		salesqita4: this.salesqita4,
		qita4salesImgs: this.qita4salesImgs_,
		buyerqita4: this.buyerqita4,
		qita4buyerImgs: this.qita4buyerImgs_,
		
		qita5name: this.qita5name,
		salesqita5: this.salesqita5,
		qita5salesImgs: this.qita5salesImgs_,
		buyerqita5: this.buyerqita5,
		qita5buyerImgs: this.qita5buyerImgs_,
		
		qita6name: this.qita6name,
		salesqita6: this.salesqita6,
		qita6salesImgs: this.qita6salesImgs_,
		buyerqita6: this.buyerqita6,
		qita6buyerImgs: this.qita6buyerImgs_,
		
		qita7name: this.qita7name,
		salesqita7: this.salesqita7,
		qita7salesImgs: this.qita7salesImgs_,
		buyerqita7: this.buyerqita7,
		qita7buyerImgs: this.qita7buyerImgs_,
		
		qita8name: this.qita8name,
		salesqita8: this.salesqita8,
		qita8salesImgs: this.qita8salesImgs_,
		buyerqita8: this.buyerqita8,
		qita8buyerImgs: this.qita8buyerImgs_,
		
		qita9name: this.qita9name,
		salesqita9: this.salesqita9,
		qita9salesImgs: this.qita9salesImgs_,
		buyerqita9: this.buyerqita9,
		qita9buyerImgs: this.qita9buyerImgs_,
		
		qita10name: this.qita10name,
		salesqita10: this.salesqita10,
		qita10salesImgs: this.qita10salesImgs_,
		buyerqita10: this.buyerqita10,
		qita10buyerImgs: this.qita10buyerImgs_,
		
	    contactUser: this.contactUser,
	    contactPhone: this.contactPhone,
        businessLicenseImgs: this.businessLicenseImgs_,
	    captcha: this.captcha,
	  };
	
	  let xhr = new XMLHttpRequest();
	  xhr.open('POST', 'https://activity.anhuiec.com/index.php?s=/api/activity/uploadAdd', true);
	  xhr.setRequestHeader('Content-type', 'application/json');
	  xhr.onreadystatechange = function () {
		  var res = JSON.parse(xhr.response);
		  // console.log(res.status);
		  if (res.status === 200) {
			this.activesStop = 1
			console.log(this.activesStop)
			Dialog({
			  title: "上传成功",
			  message: "",
			});
		  } else {
			this.activesStop = 1
			console.log(this.activesStop)
			Toast.fail(res.message);
		  }
	  };
	  
	  xhr.send(JSON.stringify({
		form: postData
	  }));
	  
	  this.$nextTick(() => {
		this.$loading().close()
	  })
	},
    saveDraft() {
      const info = {
        // 企业信息
        companyName: this.companyName,
        businessLicenseImgs: this.businessLicenseImgs,
        businessLicenseImgs_: this.businessLicenseImgs_,

        // 基本信息
        productName: this.productName,
        choosedArea: this.chooseArea,
        choosedAreaDes: this.choosedAreaDes,
        areaDetail: this.areaDetail,
        packingImgs: this.packingImgs,
        packingImgs_: this.packingImgs_,
        liveshotImgs: this.liveshotImgs,
        liveshotImgs_: this.liveshotImgs_,
        anotherProLicenseImgs: this.anotherProLicenseImgs,
        anotherProLicenseImgs_: this.anotherProLicenseImgs_,
        certification: this.certification,
        healthFoodsImgs: this.healthFoodsImgs,
        healthFoodsImgs_: this.healthFoodsImgs_,
        healthLicenseImgs: this.healthLicenseImgs,
        healthLicenseImgs_: this.healthLicenseImgs_,
        purchaseImgs: this.purchaseImgs,
        purchaseImgs_: this.purchaseImgs_,
        otherLicenseImgs: this.otherLicenseImgs,
        otherLicenseImgs_: this.otherLicenseImgs_,

        // 商标信息
        brandMethod: this.brandMethod,
        brandFrontImgs: this.brandFrontImgs,
        brandFrontImgs_: this.brandFrontImgs_,
        brandBackImgs: this.brandBackImgs,
        brandBackImgs_: this.brandBackImgs_,
        thirdBusinessLicenseImgs: this.thirdBusinessLicenseImgs,
        thirdBusinessLicenseImgs_: this.thirdBusinessLicenseImgs_,
        transferExplain: this.transferExplain,

        // 质量信息
        productMethod: this.productMethod,
        productLicenseImgs: this.productLicenseImgs,
        productLicenseImgs_: this.productLicenseImgs_,
        clientProductLicenseImgs: this.clientProductLicenseImgs,
        clientProductLicenseImgs_: this.clientProductLicenseImgs_,
        clientBusinessLicenseImgs: this.clientBusinessLicenseImgs,
        clientBusinessLicenseImgs_: this.clientBusinessLicenseImgs_,
        clientProtocolImgs: this.clientProtocolImgs,
        clientProtocolImgs_: this.clientProtocolImgs_,
        qualityImgs: this.qualityImgs,
        qualityImgs_: this.qualityImgs_,

        // 销售信息
        publishTime: this.publishTime,
        output: this.output,
        sales: this.sales,
        salesChannel: this.salesChannel,
        netChannel: this.netChannel,
        netPercent: this.netPercent,
        highReason: this.highReason,
        highReasonDes: this.highReasonDes,
        sellingPoints: this.sellingPoints,

        // 联系信息
        contactUser: this.contactUser,
        productType: this.productType,
        contactPhone: this.contactPhone,
        wxNo: this.wxNo,

        post: this.post,
        email: this.email,
        captcha: this.captcha,
      };

      try {
        localStorage.setItem("save", JSON.stringify(info));
        console.log("saved");
      } catch (error) {
        console.log("无法保存草稿");
      }
    },
    tipAgree() {
      Toast("请勾选声明");
    },
    navToStatusList() {
      this.$router.push({
        path: "/status"
      });
    },
	//taobao
	uploadtaobaosalesImgs(files) {
	  this.uploadUserImgs(files, "taobaosalesImgs_");
	},
	//tianmao
	uploadtianmaosalesImgs(files) {
	  this.uploadUserImgs(files, "tianmaosalesImgs_");
	},
	//pinduoduo
	uploadpinduoduosalesImgs(files) {
	  this.uploadUserImgs(files, "pinduoduosalesImgs_");
	},
	//jingdong
	uploadjingdongsalesImgs(files) {
	  this.uploadUserImgs(files, "jingdongsalesImgs_");
	},
	//douyin
	uploaddouyinsalesImgs(files) {
	  this.uploadUserImgs(files, "douyinsalesImgs_");
	},
	//kuaishou
	uploadkuaishousalesImgs(files) {
	  this.uploadUserImgs(files, "kuaishousalesImgs_");
	},
	//qita1
	uploadqita1salesImgs(files) {
	  this.uploadUserImgs(files, "qita1salesImgs_");
	},
	//qita2
	uploadqita2salesImgs(files) {
	  this.uploadUserImgs(files, "qita2salesImgs_");
	},
	//qita3
	uploadqita3salesImgs(files) {
	  this.uploadUserImgs(files, "qita3salesImgs_");
	},
	//qita4
	uploadqita4salesImgs(files) {
	  this.uploadUserImgs(files, "qita4salesImgs_");
	},
	//qita5
	uploadqita5salesImgs(files) {
	  this.uploadUserImgs(files, "qita5salesImgs_");
	},
	//qita6
	uploadqita6salesImgs(files) {
	  this.uploadUserImgs(files, "qita6salesImgs_");
	},
	//qita7
	uploadqita7salesImgs(files) {
	  this.uploadUserImgs(files, "qita7salesImgs_");
	},
	//qita8
	uploadqita8salesImgs(files) {
	  this.uploadUserImgs(files, "qita8salesImgs_");
	},
	//qita9
	uploadqita9salesImgs(files) {
	  this.uploadUserImgs(files, "qita9salesImgs_");
	},
	//qita10
	uploadqita10salesImgs(files) {
	  this.uploadUserImgs(files, "qita10salesImgs_");
	},
	
	//taobao删除图片
	deletetaobaosales(e, index) {
	  this.taobaosalesImgs_.splice(index.index, 1)
	  this.taobaosalesImgs.splice(index.index, 1)
	},
	//tianmao删除图片
	deletetianmaosales(e, index) {
	  this.tianmaosalesImgs_.splice(index.index, 1)
	  this.tianmaosalesImgs.splice(index.index, 1)
	},
	//pinduoduo删除图片
	deletepinduoduosales(e, index) {
	  this.pinduoduosalesImgs_.splice(index.index, 1)
	  this.pinduoduosalesImgs.splice(index.index, 1)
	},
	//jingdong删除图片
	deletejingdongsales(e, index) {
	  this.jingdongsalesImgs_.splice(index.index, 1)
	  this.jingdongsalesImgs.splice(index.index, 1)
	},
	//douyin删除图片
	deletedouyinsales(e, index) {
	  this.douyinsalesImgs_.splice(index.index, 1)
	  this.douyinsalesImgs.splice(index.index, 1)
	},
	//kuaishou删除图片
	deletekuaishousales(e, index) {
	  this.kuaishousalesImgs_.splice(index.index, 1)
	  this.kuaishousalesImgs.splice(index.index, 1)
	},
	//qita1删除图片
	deleteqita1sales(e, index) {
	  this.qita1salesImgs_.splice(index.index, 1)
	  this.qita1salesImgs.splice(index.index, 1)
	},
	//qita2删除图片
	deleteqita2sales(e, index) {
	  this.qita2salesImgs_.splice(index.index, 1)
	  this.qita2salesImgs.splice(index.index, 1)
	},
	//qita3删除图片
	deleteqita3sales(e, index) {
	  this.qita3salesImgs_.splice(index.index, 1)
	  this.qita3salesImgs.splice(index.index, 1)
	},
	//qita4删除图片
	deleteqita4sales(e, index) {
	  this.qita4salesImgs_.splice(index.index, 1)
	  this.qita4salesImgs.splice(index.index, 1)
	},
	//qita5删除图片
	deleteqita5sales(e, index) {
	  this.qita5salesImgs_.splice(index.index, 1)
	  this.qita5salesImgs.splice(index.index, 1)
	},
	//qita6删除图片
	deleteqita6sales(e, index) {
	  this.qita6salesImgs_.splice(index.index, 1)
	  this.qita6salesImgs.splice(index.index, 1)
	},
	//qita7删除图片
	deleteqita7sales(e, index) {
	  this.qita7salesImgs_.splice(index.index, 1)
	  this.qita7salesImgs.splice(index.index, 1)
	},
	//qita8删除图片
	deleteqita8sales(e, index) {
	  this.qita8salesImgs_.splice(index.index, 1)
	  this.qita8salesImgs.splice(index.index, 1)
	},
	//qita9删除图片
	deleteqita9sales(e, index) {
	  this.qita9salesImgs_.splice(index.index, 1)
	  this.qita9salesImgs.splice(index.index, 1)
	},
	//qita10删除图片
	deleteqita10sales(e, index) {
	  this.qita10salesImgs_.splice(index.index, 1)
	  this.qita10salesImgs.splice(index.index, 1)
	},
	
	//taobao
	uploadtaobaobuyerImgs(files) {
	  this.uploadUserImgs(files, "taobaobuyerImgs_");
	},
	//tianmao
	uploadtianmaobuyerImgs(files) {
	  this.uploadUserImgs(files, "tianmaobuyerImgs_");
	},
	//pinduoduo
	uploadpinduoduobuyerImgs(files) {
	  this.uploadUserImgs(files, "pinduoduobuyerImgs_");
	},
	//jingdong
	uploadjingdongbuyerImgs(files) {
	  this.uploadUserImgs(files, "jingdongbuyerImgs_");
	},
	//douyin
	uploaddouyinbuyerImgs(files) {
	  this.uploadUserImgs(files, "douyinbuyerImgs_");
	},
	//kuaishou
	uploadkuaishoubuyerImgs(files) {
	  this.uploadUserImgs(files, "kuaishoubuyerImgs_");
	},
	//qita1
	uploadqita1buyerImgs(files) {
	  this.uploadUserImgs(files, "qita1buyerImgs_");
	},
	//qita2
	uploadqita2buyerImgs(files) {
	  this.uploadUserImgs(files, "qita2buyerImgs_");
	},
	//qita3
	uploadqita3buyerImgs(files) {
	  this.uploadUserImgs(files, "qita3buyerImgs_");
	},
	//qita4
	uploadqita4buyerImgs(files) {
	  this.uploadUserImgs(files, "qita4buyerImgs_");
	},
	//qita5
	uploadqita5buyerImgs(files) {
	  this.uploadUserImgs(files, "qita5buyerImgs_");
	},
	//qita6
	uploadqita6buyerImgs(files) {
	  this.uploadUserImgs(files, "qita6buyerImgs_");
	},
	//qita7
	uploadqita7buyerImgs(files) {
	  this.uploadUserImgs(files, "qita7buyerImgs_");
	},
	//qita8
	uploadqita8buyerImgs(files) {
	  this.uploadUserImgs(files, "qita8buyerImgs_");
	},
	//qita9
	uploadqita9buyerImgs(files) {
	  this.uploadUserImgs(files, "qita9buyerImgs_");
	},
	//qita10
	uploadqita10buyerImgs(files) {
	  this.uploadUserImgs(files, "qita10buyerImgs_");
	},
	
	//taobao删除图片
	deletetaobaobuyer(e, index) {
	  this.taobaobuyerImgs_.splice(index.index, 1)
	  this.taobaobuyerImgs.splice(index.index, 1)
	},
	//tianmao删除图片
	deletetianmaobuyer(e, index) {
	  this.tianmaobuyerImgs_.splice(index.index, 1)
	  this.tianmaobuyerImgs.splice(index.index, 1)
	},
	//pinduoduo删除图片
	deletepinduoduobuyer(e, index) {
	  this.pinduoduobuyerImgs_.splice(index.index, 1)
	  this.pinduoduobuyerImgs.splice(index.index, 1)
	},
	//jingdong删除图片
	deletejingdongbuyer(e, index) {
	  this.jingdongbuyerImgs_.splice(index.index, 1)
	  this.jingdongbuyerImgs.splice(index.index, 1)
	},
	//douyin删除图片
	deletedouyinbuyer(e, index) {
	  this.douyinbuyerImgs_.splice(index.index, 1)
	  this.douyinbuyerImgs.splice(index.index, 1)
	},
	//kuaishou删除图片
	deletekuaishoubuyer(e, index) {
	  this.kuaishoubuyerImgs_.splice(index.index, 1)
	  this.kuaishoubuyerImgs.splice(index.index, 1)
	},
	//qita1删除图片
	deleteqita1buyer(e, index) {
	  this.qita1buyerImgs_.splice(index.index, 1)
	  this.qita1buyerImgs.splice(index.index, 1)
	},
	//qita2删除图片
	deleteqita2buyer(e, index) {
	  this.qita2buyerImgs_.splice(index.index, 1)
	  this.qita2buyerImgs.splice(index.index, 1)
	},
	//qita3删除图片
	deleteqita3buyer(e, index) {
	  this.qita3buyerImgs_.splice(index.index, 1)
	  this.qita3buyerImgs.splice(index.index, 1)
	},
	//qita4删除图片
	deleteqita4buyer(e, index) {
	  this.qita4buyerImgs_.splice(index.index, 1)
	  this.qita4buyerImgs.splice(index.index, 1)
	},
	//qita5删除图片
	deleteqita5buyer(e, index) {
	  this.qita5buyerImgs_.splice(index.index, 1)
	  this.qita5buyerImgs.splice(index.index, 1)
	},
	//qita6删除图片
	deleteqita6buyer(e, index) {
	  this.qita6buyerImgs_.splice(index.index, 1)
	  this.qita6buyerImgs.splice(index.index, 1)
	},
	//qita7删除图片
	deleteqita7buyer(e, index) {
	  this.qita7buyerImgs_.splice(index.index, 1)
	  this.qita7buyerImgs.splice(index.index, 1)
	},
	//qita8删除图片
	deleteqita8buyer(e, index) {
	  this.qita8buyerImgs_.splice(index.index, 1)
	  this.qita8buyerImgs.splice(index.index, 1)
	},
	//qita9删除图片
	deleteqita9buyer(e, index) {
	  this.qita9buyerImgs_.splice(index.index, 1)
	  this.qita9buyerImgs.splice(index.index, 1)
	},
	//qita10删除图片
	deleteqita10buyer(e, index) {
	  this.qita10buyerImgs_.splice(index.index, 1)
	  this.qita10buyerImgs.splice(index.index, 1)
	},
	
    //产品包装图
    uploadPackingImgs(files) {
      this.uploadUserImgs(files, "packingImgs_");
    },
    //产品实拍图
    uploadLiveshotImgs(files) {
      this.uploadUserImgs(files, "liveshotImgs_");
    },
    //保健品批准证
    uploadHealthFoodsImgs(files) {
      this.uploadUserImgs(files, "healthFoodsImgs_");
    },
    //保健品卫生许可证
    uploadHealthLicenseImgs(files) {
      this.uploadUserImgs(files, "healthLicenseImgs_");
    },
    //其他证书
    uploadOtherLicenseImgs(files) {
      this.uploadUserImgs(files, "otherLicenseImgs_");
    },
    //生产许可证
    uploadProductLicenseImgs(files) {
      this.uploadUserImgs(files, "productLicenseImgs_");
    },
    //营业执照照片
    uploadBusinessLicenseImgs(files) {
      this.uploadUserImgs(files, "businessLicenseImgs_");
    },
    //委托方生产许可证
    uploadClientProductLicenseImgs(files) {
      this.uploadUserImgs(files, "clientProductLicenseImgs_");
    },
    //委托方营业执照
    uploadClientBusinessLicenseImgs(files) {
      this.uploadUserImgs(files, "clientBusinessLicenseImgs_");
    },
    //委托加工协议
    uploadClientProtocolImgs(files) {
      this.uploadUserImgs(files, "clientProtocolImgs_");
    },
    //质检合格报告
    uploadQualityImgs(files) {
      this.uploadUserImgs(files, "qualityImgs_");
    },
    //商标注册证正面
    uploadBrandFrontImgs(files) {
      this.uploadUserImgs(files, "brandFrontImgs_");
    },
    //商标注册证反面
    uploadBrandBackImgs(files) {
      this.uploadUserImgs(files, "brandBackImgs_");
    },
    //第三方营业执照复印件
    uploadThirdBusinessLicenseImgs(files) {
      this.uploadUserImgs(files, "thirdBusinessLicenseImgs_");
    },
    //采购协议
    uploadPurchaseImgs(files) {
      this.uploadUserImgs(files, "purchaseImgs_");
    },
    //产品资质
    uploadAnotherProLicenseImgs(files) {
      this.uploadUserImgs(files, "anotherProLicenseImgs_");
    },
    // 上传图片封装  type为图片url数组
    uploadUserImgs(files, type, callback = function () {}) {
      const reg = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.JPG', '.JPEG', '.GIF', '.BMP']
      let res = [];

      if (Object.prototype.toString.call(files) == "[object Array]") {
        files.forEach((item) => {
          const name = item.file.name;
          const exts = name.split(".");
          const ext = "." + exts[exts.length - 1];
          if (reg.indexOf(ext) >= 0) {
            res.push(true)
          } else {
            res.push(false)
          }
          // res.push(true);
        });
      } else {
        const name = files.file.name;
        const exts = name.split(".");
        const ext = "." + exts[exts.length - 1];
        // res.push(true)
        if (reg.indexOf(ext) >= 0) {
          res.push(true)
        } else {
          res.push(false)
        }
        // res.push(true);
      }

      if (res.indexOf(false) >= 0) {
        Toast.fail("请上传图片类型文件");
        return;
      }

      let formData = new FormData();
      if (Object.prototype.toString.call(files) == "[object Array]") {
        files.forEach((item) => {
          formData.append("file", item.file);
        });
      } else {
        // files.forEach((item) => {
        //   formData.append("file", item.file);
        // });
        formData.append("file", files.file);
      }
      console.log(this.businessLicenseImgs_);
      this.$ajax({
        method: "post",
        url: uploadFile + this.userflag,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          const resData = res.data.data;
          const imgs = this[type];
          if (type == "businessLicenseImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                console.log(e);
                this.businessLicenseImgs_.push(e)
              })
            } else {
              this.businessLicenseImgs_.push(resData[0])
            }
          }
          if (type == "packingImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                // debugger
                this.packingImgs_.push(e)
              })
            } else {
              this.packingImgs_.push(resData[0])
            }
          }
          if (type == "liveshotImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.liveshotImgs_.push(e)
              })
            } else {
              this.liveshotImgs_.push(resData[0])
            }
          }
          if (type == "healthFoodsImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.healthFoodsImgs_.push(e)
              })
            } else {
              this.healthFoodsImgs_.push(resData[0])
            }
          }
          if (type == "healthLicenseImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.healthLicenseImgs_.push(e)
              })
            } else {
              this.healthLicenseImgs_.push(resData[0])
            }
          }
          if (type == "otherLicenseImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.otherLicenseImgs_.push(e)
              })
            } else {
              this.otherLicenseImgs_.push(resData[0])
            }
          }
          if (type == "productLicenseImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.productLicenseImgs_.push(e)
              })
            } else {
              this.productLicenseImgs_.push(resData[0])
            }
          }
          if (type == "clientProductLicenseImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.clientProductLicenseImgs_.push(e)
              })
            } else {
              this.clientProductLicenseImgs_.push(resData[0])
            }
          }
          if (type == "clientBusinessLicenseImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.clientBusinessLicenseImgs_.push(e)
              })
            } else {
              this.clientBusinessLicenseImgs_.push(resData[0])
            }
          }
          if (type == "clientProtocolImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.clientProtocolImgs_.push(e)
              })
            } else {
              this.clientProtocolImgs_.push(resData[0])
            }
          }
          if (type == "qualityImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.qualityImgs_.push(e)
              })
            } else {
              this.qualityImgs_.push(resData[0])
            }
          }
          if (type == "brandFrontImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.brandFrontImgs_.push(e)
              })
            } else {
              this.brandFrontImgs_.push(resData[0])
            }
          }
          if (type == "brandBackImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.brandBackImgs_.push(e)
              })
            } else {
              this.brandBackImgs_.push(resData[0])
            }
          }
          if (type == "thirdBusinessLicenseImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.thirdBusinessLicenseImgs_.push(e)
              })
            } else {
              this.thirdBusinessLicenseImgs_.push(resData[0])
            }
          }
          if (type == "purchaseImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.purchaseImgs_.push(e)
              })
            } else {
              this.purchaseImgs_.push(resData[0])
            }
          }
          if (type == "anotherProLicenseImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.anotherProLicenseImgs_.push(e)
              })
            } else {
              this.anotherProLicenseImgs_.push(resData[0])
            }
          }
          if (type == "taobaosalesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.taobaosalesImgs_.push(e)
              })
            } else {
              this.taobaosalesImgs_.push(resData[0])
            }
          }
          if (type == "tianmaosalesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.tianmaosalesImgs_.push(e)
              })
            } else {
              this.tianmaosalesImgs_.push(resData[0])
            }
          }
          if (type == "pinduoduosalesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.pinduoduosalesImgs_.push(e)
              })
            } else {
              this.pinduoduosalesImgs_.push(resData[0])
            }
          }
          if (type == "jingdongsalesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.jingdongsalesImgs_.push(e)
              })
            } else {
              this.jingdongsalesImgs_.push(resData[0])
            }
          }
          if (type == "douyinsalesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.douyinsalesImgs_.push(e)
              })
            } else {
              this.douyinsalesImgs_.push(resData[0])
            }
          }
          if (type == "kuaishousalesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.kuaishousalesImgs_.push(e)
              })
            } else {
              this.kuaishousalesImgs_.push(resData[0])
            }
          }
          if (type == "qita1salesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.qita1salesImgs_.push(e)
              })
            } else {
              this.qita1salesImgs_.push(resData[0])
            }
          }
          if (type == "qita2salesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.qita2salesImgs_.push(e)
              })
            } else {
              this.qita2salesImgs_.push(resData[0])
            }
          }
          if (type == "qita3salesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.qita3salesImgs_.push(e)
              })
            } else {
              this.qita3salesImgs_.push(resData[0])
            }
          }
          if (type == "qita4salesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.qita4salesImgs_.push(e)
              })
            } else {
              this.qita4salesImgs_.push(resData[0])
            }
          }
          if (type == "qita5salesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.qita5salesImgs_.push(e)
              })
            } else {
              this.qita5salesImgs_.push(resData[0])
            }
          }
          if (type == "qita6salesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.qita6salesImgs_.push(e)
              })
            } else {
              this.qita6salesImgs_.push(resData[0])
            }
          }
          if (type == "qita7salesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.qita7salesImgs_.push(e)
              })
            } else {
              this.qita7salesImgs_.push(resData[0])
            }
          }
          if (type == "qita8salesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.qita8salesImgs_.push(e)
              })
            } else {
              this.qita8salesImgs_.push(resData[0])
            }
          }
          if (type == "qita9salesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.qita9salesImgs_.push(e)
              })
            } else {
              this.qita9salesImgs_.push(resData[0])
            }
          }
          if (type == "qita10salesImgs_") {
            if (resData.length > 1) {
              resData.forEach(e => {
                this.qita10salesImgs_.push(e)
              })
            } else {
              this.qita10salesImgs_.push(resData[0])
            }
          }
		  
		  
		  if (type == "taobaobuyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.taobaobuyerImgs_.push(e)
		      })
		    } else {
		      this.taobaobuyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "tianmaobuyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.tianmaobuyerImgs_.push(e)
		      })
		    } else {
		      this.tianmaobuyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "pinduoduobuyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.pinduoduobuyerImgs_.push(e)
		      })
		    } else {
		      this.pinduoduobuyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "jingdongbuyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.jingdongbuyerImgs_.push(e)
		      })
		    } else {
		      this.jingdongbuyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "douyinbuyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.douyinbuyerImgs_.push(e)
		      })
		    } else {
		      this.douyinbuyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "kuaishoubuyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.kuaishoubuyerImgs_.push(e)
		      })
		    } else {
		      this.kuaishoubuyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "qita1buyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.qita1buyerImgs_.push(e)
		      })
		    } else {
		      this.qita1buyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "qita2buyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.qita2buyerImgs_.push(e)
		      })
		    } else {
		      this.qita2buyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "qita3buyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.qita3buyerImgs_.push(e)
		      })
		    } else {
		      this.qita3buyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "qita4buyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.qita4buyerImgs_.push(e)
		      })
		    } else {
		      this.qita4buyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "qita5buyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.qita5buyerImgs_.push(e)
		      })
		    } else {
		      this.qita5buyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "qita6buyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.qita6buyerImgs_.push(e)
		      })
		    } else {
		      this.qita6buyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "qita7buyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.qita7buyerImgs_.push(e)
		      })
		    } else {
		      this.qita7buyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "qita8buyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.qita8buyerImgs_.push(e)
		      })
		    } else {
		      this.qita8buyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "qita9buyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.qita9buyerImgs_.push(e)
		      })
		    } else {
		      this.qita9buyerImgs_.push(resData[0])
		    }
		  }
		  if (type == "qita10buyerImgs_") {
		    if (resData.length > 1) {
		      resData.forEach(e => {
		        this.qita10buyerImgs_.push(e)
		      })
		    } else {
		      this.qita10buyerImgs_.push(resData[0])
		    }
		  }
          // console.log(resData.length);
          // console.log(type == "businessLicenseImgs_");
          // console.log(this.businessLicenseImgs_);
          return
        })
        .catch((err) => {
          Toast.loading({
            message: err,
            forbidClick: true,
          });
          console.error(err);
        });
    },
    startSendSms() {
      if (!this.contactPhone) {
        Toast.fail("请输入手机号");
        return;
      } else if (!regTel(this.contactPhone)) {
        Toast.fail("请正确输入手机号");
        return;
      }
      this.sendSms = true;
      this.smsTimer();
      this.sms();
    },
    smsTimer() {
      const self = this;
      const timer = setInterval(() => {
        if (self.smsTime <= 0) {
          clearInterval(timer);
          self.sendSms = false;
          self.smsTime = 60;
          return;
        }
        self.smsTime -= 1;
      }, 1000);
    },
    sms() {
      Toast.loading({
        message: "短信发送中",
        forbidClick: true,
      });
	  let xhr = new XMLHttpRequest();
	  xhr.open('POST', 'https://activity.anhuiec.com/index.php?s=/api/captcha/sendSms', true);
	  xhr.setRequestHeader('Content-type', 'application/json');
	  xhr.onreadystatechange = function () {
	    var res = JSON.parse(xhr.responseText);
		  console.log(res)
	    if (res.status === 200) {
			Toast.clear();
			// Toast.fail(res.message);
			// this.$message({
			//    title: "短信发送成功",
			//    type: "success",
			//    message: "",
			//  })
	    } else {
			Toast.clear();
			Toast.fail(res.message);
			// this.$message({
			//    title: "错误",
			//    type: "error",
			//    message: res.message,
			//  })
		}
	  };
	  xhr.send(JSON.stringify({
		form: {
		  mobile: this.contactPhone
		}
	  }));
	  
	  
	 //  this.$ajax({
  //       method: "post",
  //       url: "https://activity.anhuiec.com/index.php?s=/api/sync/sendSms",
  //       data: {
		// 	form: {
  //             mobile: this.contactPhone
		// 	}
		// },
  //       headers: {
		// 	'content-type': 'application/json;charset=utf-8',
		// 	'storeId': '10001',
		// 	'platform': 'H5'
  //       }
  //     }).then(res => {
		// 	  Toast.clear();
	 //    // if (res.data.code != 0) {
	 //    //   this.$message({
	 //    //     title: "错误",
	 //    //     type: "error",
	 //    //     message: res.data.msg,
	 //    //   })
	 //    //   return
	 //    // } else {
	 //    //   this.$router.go(0)
	 //    // }
	 //  }).catch(err => {
  //         Toast.clear();
  //         Toast.fail("短信发送失败");
	 //  })
      // this.$ajax({
      //   url: "http://activity.anhuiec.com/api/sync/sendSms?phone=" + this.contactPhone,
      // })
      //   .then(() => {
      //     Toast.clear();
      //   })
      //   .catch(() => {
      //     Toast.clear();
      //     Toast.fail("短信发送失败");
      //   });
    },
    // handleRemove(file) {
    //   // 删除上传的图片
    //   this.$refs.imgRef.handleRemove(file)
    //   const url = file.response.data
    //   const index_1 = this.user.screenshot.match(new RegExp(url))['index']
    //   let reg = null
    //   // 替换字符串，如果是第一个字符串匹配结尾的逗号，其他位置匹配结束逗号
    //   if(index_1 === 0) {
    //     reg = new RegExp(url + ',?')
    //   } else {
    //     reg = new RegExp(',?' + url)
    //   }

    //   this.user.screenshot = this.user.screenshot.replace(reg, '')

    //   const index = this.user.otherInfos.imgArrs.findIndex(item => item == file)
    //   this.user.otherInfos.imgArrs.splice(index, 1)
    // },
    // handleAvatarSuccess(res, file) {
    //   this.user.otherInfos.imgArrs = file     
    // },
    // successUploaded(file) {
    //   if(this.user.screenshot !== '') {
    //     this.user.screenshot = this.user.screenshot + ',' + file.data
    //   } else {
    //     this.user.screenshot = file.data
    //   }
    // }

  },

  filters: {
    getresult: function (v) {
      if (v == 0) {
        return '审核中'
      }
      if (v == 1) {
        return '审核通过'
      }
      if (v == 2) {
        return '审核未通过'
      }
    },
    // 事件格式化
    formatTime(date) {
      let arrTime = date.split(' ')
      return arrTime[0]
    }
  }
}